import React, { useState } from "react";
import styles from "./StaffAttendancePage.module.css";
import TabSelector from "../../components/TabSelector/TabSelector";
import StaffDailyAttendanceView from "../../sections/StaffDailyAttendanceView/StaffDailyAttendanceView";
import StaffMonthlyAttendanceView from "../../sections/StaffMonthlyAttendanceView/StaffMonthlyAttendanceView";
import Dropdown from "../../components/Dropdown/Dropdown";
import CopyRight from "../../components/CopyRight/CopyRight";

const StaffAttendancePage = () => {
  const [activeTab, setActiveTab] = useState("Daily");

  const tabOptions = [{ label: "Daily" }, { label: "Monthly" }];

  return (
    <div className={styles.copyright}>
      <div className={styles.pageContainer}>
        <div className={styles.filtersRow}>
          <Dropdown
            label="Program"
            options={["Annual Day", "Sports Day", "Science Fair"]}
            bgColor="var(--Utility_Color1)"
            onChange={(val) => console.log("Selected Program:", val)}
          />
          <Dropdown
            label="Group"
            options={["Group A", "Group B", "Group C"]}
            bgColor="var(--Utility_Color1)"
            onChange={(val) => console.log("Selected Group:", val)}
          />
          <Dropdown
            label="Room"
            options={["Room 1", "Room 2", "Room 3"]}
            bgColor="var(--Utility_Color1)"
            onChange={(val) => console.log("Selected Room:", val)}
          />
          <TabSelector
            options={tabOptions}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </div>

        <div className={styles.tabContent}>
          {activeTab === "Daily" && <StaffDailyAttendanceView />}
          {activeTab === "Monthly" && <StaffMonthlyAttendanceView />}
        </div>
      </div>
      <CopyRight />
    </div>
  );
};

export default StaffAttendancePage;
